"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS_PER_PAGE = exports.LIST_PADDING = exports.ITEM_GAP = exports.FILTERING_TOOLS_REM_WIDTH = exports.REM = exports.ICON_REM_WIDTH = exports.ROW_PIXEL_HEIGHT = void 0;
exports.ROW_PIXEL_HEIGHT = 50;
exports.ICON_REM_WIDTH = 2.5;
exports.REM = 13;
exports.FILTERING_TOOLS_REM_WIDTH = 4;
exports.ITEM_GAP = exports.REM * 2;
exports.LIST_PADDING = exports.REM * 3;
exports.ITEMS_PER_PAGE = [50, 100, 350, 700, 1400];
